import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { portalPersonaGuard, portalReadyGuard } from './core/portal/portal-persona.guard';

export const routes: Routes = [
  {
    // The default landing route, rendered full-screen outside the app shell (no nav
    // rail / top bar). No credential fields — clicking "Sign in" redirects to the
    // broker, which redirects to Entra.
    path: 'login',
    loadChildren: () => import('./features/login/routes').then((m) => m.LOGIN_ROUTES),
  },
  {
    // redirect_uri registered with the broker's SpaClients config for this client.
    path: 'auth-callback',
    loadComponent: () => import('./core/auth/auth-callback').then((m) => m.AuthCallback),
  },
  {
    // returnUrl target for the broker-hosted impersonation picker (Pages/Impersonate.cshtml) —
    // registered the same way auth-callback is, just for a different broker-side redirect.
    path: 'impersonate-callback',
    loadComponent: () => import('./core/auth/impersonate-callback').then((m) => m.ImpersonateCallback),
  },
  {
    // Has to stay ahead of the layout route below, which also matches an empty
    // path — otherwise this redirect never fires.
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    // Layout route: the app shell wraps every authenticated screen, rendering
    // the matched child into its internal <router-outlet>. Guarded — an
    // unauthenticated visitor gets redirected to /login (see auth.guard.ts).
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./layout/shell/app-shell').then((m) => m.AppShell),
    children: [
      {
        path: 'home',
        canActivate: [portalReadyGuard],
        loadComponent: () => import('./features/home/home').then((m) => m.Home),
      },
      {
        path: 'portal-access',
        loadComponent: () => import('./features/portal-access/portal-access').then((m) => m.PortalAccess),
      },
      {
        // Party-facing external surface. Its case data must remain scoped to the signed-in
        // organization; the route group keeps that boundary separate from staff and reviewer UI.
        path: 'party',
        canActivate: [portalPersonaGuard('party')],
        loadChildren: () => import('./features/party/routes').then((m) => m.PARTY_ROUTES),
      },
      {
        // Reviewer-facing external surface. Reviewer-specific authorization and assignment-only
        // case access are added with the first reviewer feature.
        path: 'reviewer',
        canActivate: [portalPersonaGuard('reviewer')],
        loadChildren: () => import('./features/reviewer/routes').then((m) => m.REVIEWER_ROUTES),
      },
      {
        // Manual smoke test for the IDR.ExternalApi -> ForthrightPayments integration (see
        // IDR.ExternalApi's PaymentsTestController). Not a production screen - no nav-rail entry,
        // reached by URL only. Kept around as a standing way to re-verify the integration end to
        // end, same role as Desk's docgen-test route.
        path: 'payments-test',
        loadChildren: () => import('./features/payments-test/routes').then((m) => m.PAYMENTS_TEST_ROUTES),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];
